import React, { useState, useEffect } from "react";
import { useNavigate, useParams ,useLocation} from "react-router-dom";
import CoachLayout from "../common/CoachLayout";
import { CoachHeader } from "../common/CoachHeader";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import API_URL from "../../api/API";

import workout from "../../images/workout.png";
import lady from "../../images/lady.png";
import video from "../../images/video.svg";
import plus from "../../images/plus.svg";
import upload from "../../images/upload.svg";
import greenClock from "../../images/greenClock.svg";

export const CoachStaticSpeedWorkoutSprints = () => {
  const navigate = useNavigate();

  const location = useLocation();
    // Access templates data passed via location.state
    const templates = location.state?.templates;

  const { coach } = useCoachAuthContext();
  const { theme_id, warmup_routine_id, template_id } = useParams();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [speedWorkout, setSpeedWorkout] = useState(null);
  const [workoutData, setWorkoutData] = useState([]); // State to hold fetched data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [showPopup, setShowPopup] = useState(false);

  const [showVideo, setShowVideo] = useState(false);

  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [message, setMessage] = useState("");

  const handleTTPopupClick = () => {
    setShowPopup(true);
  };

  const getYoutubeThumbnail = (url) => {
    // Extract the YouTube video ID from the URL
    const videoId = url.split("v=")[1]?.split("&")[0];
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };


const handleSendMessage = async () => {
  try {
    const response = await fetch(`${API_URL.SEND_COACH_MESSAGE_TO_AMAX}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${coach.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sender_id: coach.id, sender_type:'coach', receiver_id:'amax-staff' ,receiver_type:'amax', message, message_id:'parent' }),
    });

    const data = await response.json();
    if (response.ok) {
      alert('Message sent successfully!');
      setMessage('');
      setShowMessagePopup(false);
    } else {
      alert(data.error || 'Failed to send the message');
    }
  } catch (error) {
    alert('An error occurred while sending the message');
  }
};

const fetchWorkoutData = async () => {
  try {
    const response = await fetch(`${API_URL.GET_COACH_STATIC_WORKOUT_SPRINTS_BY_THEME}${theme_id}`,{
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${coach.token}`,
        'Content-Type': 'application/json'
      }
      
    });
    const data = await response.json();

    console.log(data);

    if (response.ok) {
      setWorkoutData(data); // Set the sprints data from API
    } else {
      setError(data.error); // Set error if any
    }
  } catch (error) {
    setError('Failed to fetch workout data'); // Set error in case of failure
  } finally {
    setLoading(false); // Set loading to false after fetching
  }
};

  // Fetch workout data from the API
  useEffect(() => {
    fetchWorkoutData();
  }, [theme_id]);

  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const handleAccordionClick = (index) => {
    setSpeedWorkout(speedWorkout === index ? null : index);
  };

  const handleStaticWarmupClick = () => {
    navigate("/coach/static-warmup-routine/phase/" + warmup_routine_id + "/" + template_id,{ state: { templates } });
  };

    // Handle back button click and pass templates state back
    const handleBackClick = () => {
      navigate(-1); // Pass templates back on go back
    };
  

  return (



    <CoachLayout>
      <div className="bg-white">
        <CoachHeader />
      </div>
      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">


        <div className="w-full text-center relative py-4">
            <span
              className="absolute left-5 top-1/2 -translate-y-1/2 flex items-center gap-2 cursor-pointer text-white hover:text-gray-300"
              onClick={handleBackClick}
            >
              <BackArrow /> Back
            </span>
          </div>

          <div className="flex justify-between gap-[68px] mb-4 px-5">
            <button onClick={handleStaticWarmupClick} className="text-lightSmock text-base pb-2 font-normal">
              Warmup Routine
            </button>
            <button className="text-white border-b-2 border-white text-base pb-2 font-normal">
              Speed Workout
            </button>
          </div>



          {loading ? (
            <p className="text-white text-center">Loading Sprints...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>
          ) : (
          <div>

          <div className={`${speedWorkout !== null ? "hidden" : "block"} relative after:bg-gradient-to-b after:from-black/0 after:from-50% after:to-black/40 after:to-80% after:absolute after:bottom-0 after:w-full after:h-full`}>
            <img src={workout} alt="workout" className={`w-full h-[204px] ${speedWorkout !== null ? "hidden" : "block"}`} />
            <div className="flex justify-between items-center text-white p-5 w-full absolute bottom-5 z-10">
              <p className="text-xl font-normal">{workoutData.title}</p>
              <p className="text-sm font-normal">{workoutData.total_distance} m</p>
            </div>
          </div>

          <div className={`${speedWorkout !== null ? "block" : "hidden"} p-[20px_20px_40px_20px] flex justify-between items-center text-black bg-white`}>
            <p className="text-xl font-normal">{workoutData.title}</p>
            <p className="text-sm font-normal">{workoutData.total_distance} m</p>
          </div>



          {showPopup && (
            <PopupMessage 
              message="This is only available to Amax coached athletes!" 
              onClose={() => setShowPopup(false)} 
            />
          )}     

          {showMessagePopup && (
            <MessageCoachPopup 
              onClose={() => setShowMessagePopup(false)} 
              message={message} 
              setMessage={setMessage} 
              onSend={handleSendMessage} 
            />
          )}


          <div className="flex flex-col px-5 !rounded-t-[20px] -mt-5 relative z-10 bg-black">
            {workoutData.sprints.map((item, index) => (
              <div key={index} className="bg-transparent py-5 border-b border-white/20">
                <div className="flex flex-row justify-between items-center text-center cursor-pointer" onClick={() => handleAccordionClick(index)}>
                  <div className="space-y-2">
                    <label className="text-[#a5a5a5] text-xs font-normal uppercase">Sets</label>
                    <p>{item.sets}</p>
                  </div>
                  <div className="space-y-2">
                    <label className="text-[#a5a5a5] text-xs font-normal uppercase">Reps</label>
                    <p>{item.reps}</p>
                  </div>
                  <div className="space-y-2">
                    <label className="text-[#a5a5a5] text-xs font-normal uppercase">Distance</label>
                    <p>{item.distance}</p>
                  </div>
                  <div className="space-y-2">
                    <label className="text-[#a5a5a5] text-xs font-normal uppercase">T/T</label>
                    <span className="relative group">
                      <p>N/A</p>
                      <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden w-max px-2 py-1 text-xs text-white bg-gray-700 rounded-md opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-300">
                      This is only available to Amax coached athletes
                      </span>
                    </span>
                  </div>
                  <span className="cursor-pointer">
                    <ArrowWhite />
                  </span>
                </div>
                {speedWorkout === index && (
                  <>
                    <div className="text-white text-sm font-normal mt-3">
                      <p><span className="uppercase">Rest: </span>{item.rest}</p>
                      <p className="mt-3"><span className="uppercase">Notes: </span>{item.notes}</p>
                      <button 
                        onClick={() => setShowMessagePopup(true)} 
                        className="border border-white py-6 px-10 w-full max-w-sm mx-auto rounded-[70px] block my-[30px] uppercase font-semibold">
                        Message the Coach
                      </button>
                    </div>
                    <div className="w-full flex flex-row gap-[15px] mb-[15px]">
                    
                       {/* Thumbnail Container */}
                        <div className="w-1/2 h-[120px] border border-white/10 rounded-[15px] overflow-hidden cursor-pointer" onClick={() => item.video_url && setShowVideo(true)}>
                          {item.video_url ? (
                            <img src={getYoutubeThumbnail(item.video_url)} alt="YouTube Thumbnail" className="object-cover w-full h-full" />
                          ) : (
                            <img src={lady} alt="lady" className="object-cover w-full h-full" />
                          )}
                        </div>

                         {/* Video Popup */}
                          {showVideo && (
                            <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                              <div className="relative w-[80%] h-[80%] bg-black">
                                <iframe
                                  src={`${item.video_url.replace("watch?v=", "embed/")}`}
                                  title="YouTube video"
                                  className="w-full h-full"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                ></iframe>
                                <button
                                  className="absolute top-2 right-2 text-white text-2xl bg-black bg-opacity-50 rounded-full p-2"
                                  onClick={() => setShowVideo(false)}
                                >
                                  ✕
                                </button>
                              </div>
                            </div>
                          )}


                      <div className="w-1/2 h-[120px] border border-white/10 p-[15px] rounded-[15px] overflow-hidden">
                        <img src={video} alt="video" className="object-contain mb-6 cursor-pointer" />
                        <p className="text-white text-sm font-normal mb-3">Upload video</p>
                        <img onClick={handleTTPopupClick}  src={upload} alt="upload" className="object-contain cursor-pointer" />
                      </div>
                    </div>
                    <div className="p-[19px] flex justify-between items-center">
                      <p className="text-xl font-normal">Actual Time</p>
                        <img src={greenClock} alt="greenClock" className="object-contain cursor-pointer" />
                    </div>
                    <div className="p-[19px] flex justify-between items-center">
                      <div className="relative w-full">
                        <input type="text"  className="placeholder:text-[#5D5D5D] placeholder:font-medium text-white text-xl font-normal bg-transparent w-full outline-none pr-12" placeholder="Actual time" />
                        <img onClick={handleTTPopupClick} src={plus} alt="plus" className="absolute right-0 top-1/2 -translate-y-1/2" />
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>

          </div>  
          )}

        </div>
      </div>




    </CoachLayout>
  );
};

const BackArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="white"
        d="M15 19l-7-7 7-7"
      />
    </svg>
  );
};

const PopupMessage = ({ message, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white p-5 rounded shadow-lg text-center">
      <p className="text-black text-sm font-semibold">{message}</p>
      <button 
        onClick={onClose} 
        className="mt-3 px-4 py-2 bg-black text-white rounded hover:opacity-80">
        Close
      </button>
    </div>
  </div>
);

const MessageCoachPopup = ({ onClose, message, setMessage, onSend }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-md">
      <h2 className="text-black text-lg font-semibold mb-4">Message the Coach</h2>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows="4"
        className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring focus:ring-indigo-500 text-black placeholder-gray-500"
        placeholder="Type your message here..."
      />
      <div className="mt-4 flex justify-end space-x-3">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-black rounded hover:bg-gray-300">
          Cancel
        </button>
        <button
          onClick={onSend}
          className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800">
          Send
        </button>
      </div>
    </div>
  </div>
);


const ArrowG = ({ onClick }) => (
  <svg onClick={onClick} className="hover:opacity-50 cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowL = ({ onClick }) => (
  <svg onClick={onClick} className="hover:opacity-50 rotate-180 cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowWhite = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
      <path d="M1 0.999999L7 7L13 1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
